import { GINGIVA, type Gingiva } from '@witmetrics/unison-core';
import ToggleBlock, { ToggleOption } from '@/components/ToggleBlock';
import { CheckBoxIcon, UncheckBoxIcon } from '@/icons';
import { classes } from './utils';

const { MANDIBLE, MAXILLA } = GINGIVA;

export type ArchToggleProps = {
  visibleArches: Gingiva[];
  onChange: (visibleArches: Gingiva[]) => void;
};

export default function ArchToggle({
  visibleArches,
  onChange,
}: ArchToggleProps) {
  return (
    <ToggleBlock<Gingiva[]>
      exclusive={false}
      className={classes.toggleBlock}
      value={visibleArches}
      onChange={(update) => onChange(update)}>
      <ToggleOption key={MAXILLA} value={MAXILLA} tooltip="Show upper arch [u]">
        {visibleArches.includes(MAXILLA) ? (
          <CheckBoxIcon />
        ) : (
          <UncheckBoxIcon />
        )}
        <span className={classes.label}>Upper</span>
      </ToggleOption>
      <ToggleOption
        key={MANDIBLE}
        value={MANDIBLE}
        tooltip="Show lower arch [l]">
        {visibleArches.includes(MANDIBLE) ? (
          <CheckBoxIcon />
        ) : (
          <UncheckBoxIcon />
        )}
        <span className={classes.label}>Lower</span>
      </ToggleOption>
    </ToggleBlock>
  );
}
